import { FormikHelpers } from "formik";
import NodeForm from "./NodeForm";
import { useGetNode } from "./api/getNode";
import { useEditNode } from "./api/editNode";


const EditNode = ({handleCloseModal, nodeId}: EditNodeProps)  => {
  const getNodeQuery = useGetNode({nodeId: nodeId})
  const editNodeMutation = useEditNode({data: {}, nodeId});
  
  const initialValues: IEditNodeForm = {
    description: getNodeQuery.data?.description ? getNodeQuery.data?.description :"",
    modelID: getNodeQuery.data?.modelID ? getNodeQuery.data?.modelID.toString() : "",
    unitID: getNodeQuery.data?.unitID ? getNodeQuery.data?.unitID.toString() : "",
    hostName: getNodeQuery.data?.hostName ? getNodeQuery.data?.hostName : "",
    x25NodeAddress: getNodeQuery.data?.x25NodeAddress ? getNodeQuery.data?.x25NodeAddress : "",
    x25NodeNumber: getNodeQuery.data?.x25NodeNumber ? getNodeQuery.data?.x25NodeNumber : "",
    filepath: getNodeQuery.data?.filepath ? getNodeQuery.data?.filepath : "",
    address: getNodeQuery.data?.address ? getNodeQuery.data?.address : "",
    isEmporiki: getNodeQuery.data?.isEmporiki ? getNodeQuery.data?.isEmporiki : false,
    isCiti: getNodeQuery.data?.isCiti ? getNodeQuery.data?.isCiti : false,
  };

  const unitType: string | undefined = getNodeQuery.data?.unitType

  const handleSubmit = async (values: IEditNodeForm, { setSubmitting }: FormikHelpers<IEditNodeForm>): Promise<void> => {
    editNodeMutation.mutateAsync({
      data: values,
      nodeId: nodeId
    })

    setSubmitting(false);
    handleCloseModal();
  }

  return (
    <>
      {!getNodeQuery.isLoading && getNodeQuery.data &&
        <NodeForm initialValues={initialValues} unitType={unitType}  />
      }
    </>
  )
}

interface EditNodeProps {
  nodeId: number;
  handleCloseModal: () => void;
}

export default EditNode;